import { Injectable } from '@angular/core';
import { Contacts } from '@capacitor-community/contacts';
import { Capacitor } from '@capacitor/core';
import { TranslateService } from '@ngx-translate/core';
export interface Contact {
  contactId: string;
  name: string;
  phoneNumbers: { number: string; type: string }[];
  emails: { address: string; type: string }[];
  urls?: string[];
  birthday?: { day: number; month: number; year?: number };
  organization?: { company: string; jobTitle: string };
}

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor( private translate:TranslateService) {}

  // Request permissions to access contacts
  async requestPermissions(): Promise<boolean> {
    const { contacts } = await Contacts.requestPermissions();
    return contacts === 'granted';
  }


// Function to open the app settings page on iOS
async openSettings() {
  if (Capacitor.getPlatform() === 'ios') {
    // Translate "Open Settings" message based on the current language
    const openSettingsMessage = await this.translate.get('OPEN_SETTINGS').toPromise();
    // You can either show the translated message in an alert or use it as needed
    alert(openSettingsMessage);

    // Open the settings for your app on iOS
    const appSettingsUrl = 'app-settings:';
    window.open(appSettingsUrl, '_system');
  }
}

  // Fetch contacts with the required fields
  async getContacts(): Promise<any[]> {
  const hasPermission = await this.requestPermissions();

  if (!hasPermission) {
    const message = await this.translate.get('CONTACT_PERMISSION_REQUIRED').toPromise();
    alert(message);
    this.openSettings();  
    return [];
  }

    try {
      const projection = {
        name: true,
        organization: true,
        birthday: false,
        note: false,
        phones: false,
        emails: false,
        urls: false,
        postalAddresses: false,
        image: false 
      };
      
      const result = await Contacts.getContacts({ projection });
      return result.contacts || [];
      
    } catch (error) {
       //alert('Error fetching contacts: ' + error);
      return [];
    }
  }


  mapContacts(rawContacts: any[]): Contact[] {
    return rawContacts.map((contact) => ({
      contactId: contact.contactId || '',
      name: contact.name?.display || 'Unknown',
      phoneNumbers: contact.phones?.map((phone: any) => ({
        number: phone.number,
        type: phone.type
      })) || [],
      emails: contact.emails?.map((email: any) => ({
        address: email.address,
        type: email.type
      })) || [],
      urls: contact.urls || [],
      birthday: contact.birthday ? {
        day: contact.birthday.day,
        month: contact.birthday.month,
        year: contact.birthday.year || undefined
      } : undefined,
      organization: contact.organization ? {
        company: contact.organization.company || '',
        jobTitle: contact.organization.jobTitle || ''
      } : undefined
    }));
  }
}
